import { prefetchPosthog } from "@/lib/posthog-browser";

prefetchPosthog();
